import { Modal, Tooltip } from "antd";
import {
  EnvironmentOutlined,
  GithubOutlined,
  LinkedinOutlined
} from '@ant-design/icons';
import "./AboutModal.css";
import { SiJavascript, SiMysql, SiNodedotjs, SiPostgresql, SiPostman, SiReact, SiSass } from "react-icons/si";
import { DiVisualstudio } from "react-icons/di";

const AboutModal = ({ visible, onCancel }) => {
  return (
    <>
      <Modal
        className="about-modal"
        onCancel={onCancel}
        open={visible}
        width="35vw"
        style={{ minWidth: 280 }}
        centered
        zIndex={1000}
        destroyOnHidden
        footer={null}
        title="Call me Nhat"
      >
        <div className="about-modal-container">
          <p className="about-modal-intro-text">I like coding, love learning, and yearn contributing to anything that
            makes this world marginally better.
          </p>

          {/* Tech stacks here */}
          <div className="tech-stacks-container">
            <SiSass className="tech-stacks-icon" color="#CD6799" />
            <SiJavascript className="tech-stacks-icon" color="#F7DF1E" />
            <SiPostman className="tech-stacks-icon" color="#FF6C37" />
            <SiNodedotjs className="tech-stacks-icon" color="#68A063" />

            <SiReact className="tech-stacks-icon" color="#61DAFB" />
            <SiPostgresql className="tech-stacks-icon" color="#336791" />
            <SiMysql className="tech-stacks-icon" color="#4479A1" />
            <DiVisualstudio className="tech-stacks-icon" color="#007ACC" />

          </div>
          <div className="contact-top-row">
            <Tooltip placement="top" title="With a California dream">
              <span className="location">
                <EnvironmentOutlined />
                Canada
              </span>
            </Tooltip>

            <div className="social-icons">
              <LinkedinOutlined style={{ color: "#0A66C2" }}
                onClick={() => window.open("https://www.linkedin.com/in/nhat-truong-510980242/", "_blank")} />
              <GithubOutlined style={{ color: "#8534F3" }}
                onClick={() => window.open('https://github.com/nhat2105', "_blank")} />

            </div>
          </div>

        </div>


      </Modal>
    </>
  )
};

export default AboutModal;
